import { createFileRoute } from "@tanstack/react-router";
import { SettingsAccount } from "@/screens/ParentSettingsSections";
// MA-861: Account is the Settings index again, unchanged from main; Device
// mode (parked here by MA-858) moved to "This device".
export const Route = createFileRoute("/parent/settings/")({ component: SettingsAccount });
